import script from "./TenantContractView.vue?vue&type=script&setup=true&lang=js"
export * from "./TenantContractView.vue?vue&type=script&setup=true&lang=js"

import "./TenantContractView.vue?vue&type=style&index=0&id=514e80fa&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-514e80fa"]])

export default __exports__